import { render, staticRenderFns } from "./WorkIconNavProcessSupport.vue?vue&type=template&id=b4212eb6"
import script from "./WorkIconNavProcessSupport.vue?vue&type=script&lang=js"
export * from "./WorkIconNavProcessSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports